<script>
    import {publishConfigStore, tenantKeyStore} from "../core/app-store.js";
</script>

<style>

    header {
        text-align: center;
        padding-bottom: 1rem;
    }
    header .header h1 {
        font-size: 2.25em;
        font-weight: 400;
        color: var(--accent);
        text-transform: uppercase;

        padding: 2.5rem 1.6rem 2rem 1.6rem;
        margin: 0;
        max-width: 100%;
        overflow-wrap: break-word;
    }
    .header .header-image-container {
        padding: 0 .75rem;
    }
    .header .header-image {
        position: relative;
        display: block;
        background: lightgray;
        width: 100%;
        height: 33vh;
        border-bottom-left-radius: 20rem;
        border-bottom-right-radius: 20rem;
        overflow: hidden;
    }
    .header .header-image object,
    .header .header-image img {
        object-fit: cover;
    }
    .header .header-image .header-text {
        position: absolute;
        z-index: 100;
        top: -100%;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.25rem 0.75rem;
        opacity: 1;
        animation: header-text-anim .3s ease 1s 1 normal forwards;
    }
    @keyframes header-text-anim {
        from {
            top: -100%;
            opacity: .2;
        }
        to {
            top: 0;
            opacity: 1;
        }
    }
    .header .header-image .header-text span {

        box-shadow: 0 4px 8px 0 rgb(0 0 0 / 5%);
        padding: 0.25rem 0.7rem;
        line-height: 125%;
        margin: .5rem;
        border-radius: 3rem;
        width: fit-content;

        background: rgba(255, 255, 255, 0.6);
    }
    .header .header-image .header-text--paddings-no {
        padding: 0;
    }
    .header .header-image .header-text--dark span {
        background: rgba(1, 1, 1, 0.6);
        color: rgba(255, 255, 255, 1);
    }
    .header .header-image .header-text--green span {
        background: rgb(78 193 88);
        color: rgba(255, 255, 255, 1);
    }
    .header .header-image .header-text--blue span {
        background: rgba(41, 114, 205,1);
        color: rgba(255, 255, 255, 1);
    }
    .header .header-image .header-text--orange span {
        background: var(--accent);
        color: rgba(255, 255, 255, 1);
    }
    .header .header-image .header-text--red span {
        background: rgba(169, 31, 31, 0.8);
        color: rgba(255, 255, 255, 1);
    }
    .header .header-image .header-text--top {align-items: flex-start;}
    .header .header-image .header-text--middle {align-items: center;}
    .header .header-image .header-text--center {justify-content: center;}
    .header .header-image .header-text--left {justify-content: start;}
    .header .header-image .header-text--right {justify-content: end;}
    .header .logo-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 5rem;
        margin-top: 2rem;
        margin-bottom: -.5rem;
        z-index: 200;
        position: relative;
    }
    .header .header-image ~ .logo-container {
        margin-top: -2.5rem;
        margin-bottom: -.5rem;
    }
    .header .logo-container .logo-image {
        background: white;
        height: 6rem;
        width: 6rem;
        border-radius: 50%;
        border: 4px solid #f0f0f0;
        object-fit: contain;
    }

    @media (min-width: 768px) {
        header {
            display: flex;
            justify-content: center;
            padding-top: 1.5rem;
        }

        .header {
            max-width: 768px;
            width: 100%;
        }
        header .header h1 {
            font-size: 3.25em;
        }

        .header-image-container {
            display: flex;
            justify-content: center;
        }
        .header .header-image {
            height: 300px;
            width: 24vw;
            border-bottom-left-radius: 500px;
            border-bottom-right-radius: 500px;
        }
    }

    .rest-desc {
        padding: 0 1.25rem;
        margin: 0;
        font-size: var(--fs-100);
        color: var(--primary-text);
    }

    .button--phone {
        width: fit-content;
    }
    .button--phone svg {
        line-height: 1;
        vertical-align: middle;
    }

</style>

<!-- HEADER -->
<header class="layer-sections">
    <div class="header">

        {#if ( ($publishConfigStore.headerImage || '').length > 0 )}
            <div class="header-image-container">
                <div class="header-image" style:height="{$publishConfigStore.headerImageHeight || 33}vh">

                    <object class="full-width full-height"
                            data="https://digital-menu-ru.2men.us/{$tenantKeyStore}{$publishConfigStore.headerImage}"
                            type="image/png">
                        <img class="full-width full-height"
                             src="./images/fallback-header-image.svg"
                             loading="lazy"
                             alt={$publishConfigStore.restaurantName}>
                    </object>

                    {#if ($publishConfigStore.headerTexts?.length > 0 && $publishConfigStore.headerTexts[0].text?.length)}
                        <div class="header-text header-text--paddings-no header-text--top header-text--center
                            {$publishConfigStore.headerTexts[0].colors === 'black-white' ? 'header-text--dark' : $publishConfigStore.headerTexts[0].colors === 'red' ? 'header-text--red' : $publishConfigStore.headerTexts[0].colors === 'blue' ? 'header-text--blue' : $publishConfigStore.headerTexts[0].colors === 'green' ? 'header-text--green' : $publishConfigStore.headerTexts[0].colors === 'orange' ? 'header-text--orange' : ''}
                            ">
                            <span>{ $publishConfigStore.headerTexts[0].text }</span>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}

        <h1>{$publishConfigStore.restaurantName}</h1>

        <div class="flex-vertical gap-1">
            {#if ($publishConfigStore.restaurantDescription)}
                <p class="rest-desc">{$publishConfigStore.restaurantDescription}</p>
            {/if}

            {#if ($publishConfigStore.headerActions)}
                <p class="flex flex-column gap-1 fs-100 ai-center jc-center">
                    {#each $publishConfigStore.headerActions as action}

                        <a class="button button--phone" class:phone-btn--text={action.link === undefined} href="{ action.link }" target="{ action.target }" rel="nofollow noopener">
                            {#if (action.icon === 'phone')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Phone"><path d="M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"/></svg>
                            {/if}
                            {#if (action.icon === 'location')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Location"><circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z"/></svg>
                            {/if}
                            {#if (action.icon === 'map')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Map"><path d="M8.368 4.79l-2.736-.913A2 2 0 0 0 3 5.775v11.783a2 2 0 0 0 1.368 1.898l4 1.333a2 2 0 0 0 1.264 0l4.736-1.578a2 2 0 0 1 1.264 0l2.736.912A2 2 0 0 0 21 18.224V6.442a2 2 0 0 0-1.367-1.898l-4-1.333a2 2 0 0 0-1.265 0L9.631 4.789a2 2 0 0 1-1.264 0z"/><path d="M9 5v16"/><path d="M15 3v16"/></svg>
                            {/if}
                            {#if (action.icon === 'calendar')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Calendar"><rect x="2" y="4" width="20" height="18" rx="4"/><path d="M8 2v4"/><path d="M16 2v4"/><path d="M2 10h20"/></svg>
                            {/if}

                            {#if (action.text && action.text.length > 0)}
                                <span>{ action.text }</span>
                            {/if}
                        </a>

                    {/each}
                </p>
            {/if}
        </div>

    </div>
</header>
